<p class="title">Gestionar etiquetas</p>
<bdr-input-multiple class="input-multiple" [separator]="' '" [numeric]="numeric" [model]="model" [error]="error"
  [errorMsg]="errorMsg" (modelChange)="model = $event">
</bdr-input-multiple>
<bdr-button primary size="small" class="button" (click)="apply()">Aceptar</bdr-button>